import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

const LooIcon = ({ fill='#d1d1d1', border='#000', ...props}) => {
  const { loo_chances } = props;
  let fill1 = '#d1d1d1', fill2 = '#d1d1d1', fill3 = '#d1d1d1';
  let viewbox = '0 0 41.936 28.409'
  if (loo_chances == 'HIGH_PROB') {
    fill1 = '#f9a11e', fill2 = '#f9a11e', fill3 = '#f9a11e';
  } else if (loo_chances == 'MEDIUM_PROB') {
    fill1 = '#f9a11e', fill2 = "#f9a11e";
  } else if (loo_chances == 'LOW_PROB') {
    fill1 = "#f9a11e";
  }

  // loo_chances possible values NOT_AVAIL_PROB, HIGH_PROB, MEDIUM_PROB, LOW_PROB, 0

  if(loo_chances == 'HIGH_PROB' || loo_chances == 'MEDIUM_PROB' || loo_chances == 'LOW_PROB'){
    return <Icon viewBox={viewbox} {...props}>
      <g transform="translate(-642.278 -751.561)">
          <path d="M1.02,36.856V34.582a4.993,4.993,0,0,1,9.986,0v2.273A3.846,3.846,0,0,1,7.166,40.7h-2.3a3.846,3.846,0,0,1-3.841-3.841Z" transform="translate(641.258 739.986)" fill={fill1}/>
          <path d="M7.964,40.724V29.432a4.993,4.993,0,0,1,9.986,0V40.724a3.846,3.846,0,0,1-3.841,3.841h-2.3a3.846,3.846,0,0,1-3.841-3.841Z" transform="translate(646.474 736.118)" fill={fill2}/>
          <path d="M14.908,44.582V24.295a4.993,4.993,0,0,1,9.986,0V44.582a3.846,3.846,0,0,1-3.841,3.841h-2.3a3.846,3.846,0,0,1-3.841-3.841Z" transform="translate(651.689 732.26)" fill={fill3}/>
      </g>
    </Icon>
  } else {
    return <Icon viewBox={viewbox} {...props}>
      <g transform="translate(0.532 -0.001)">
        <path d="M5461.934,5059.867a4.81,4.81,0,1,1,3.4,1.411A4.829,4.829,0,0,1,5461.934,5059.867Zm-12.262,0a4.811,4.811,0,1,1,3.4,1.411A4.835,4.835,0,0,1,5449.672,5059.867Zm-12.26,0a4.809,4.809,0,1,1,3.4,1.411A4.834,4.834,0,0,1,5437.412,5059.867Z" transform="translate(-5436 -5051.657)" fill={fill1}/>
      </g>
    </Icon>
  }
};

LooIcon.propTypes = {
  fill: PropTypes.string,
  border: PropTypes.string,
};

export default LooIcon;
